module.exports = __webpack_public_path__ + "static/media/css-logo.174ea553.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/css-logo.png
// module id = 500
// module chunks = 0